import { Component, OnInit } from '@angular/core';
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, EMPTY, retry, throwError } from 'rxjs';

@Component({
  selector: 'app-cert',
  templateUrl: './cert.component.html',
  styleUrls: ['./cert.component.scss'],
})
export class CertComponent implements OnInit {

  excelData: any[];
  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly SelectionType = SelectionType;
  allomany
  overwrite = false
  cdis = false;
  uploading = false;
  file
  certPassword = ""
  sajatIntezmeny
  certdata
  certused

  // A bizonyítvány aláírója: igazgatói (személyes) tanúsítvány jelölése + figyelmeztetések (backend: utils.alairoAllapot)
  alairo: any = null;

  // Digitális aláírás időbélyeg (TSA) beállítása
  tsaEnabled = false;
  tsaUrl = "http://timestamp.digicert.com";
  tsaMentes = false;

  constructor(private http: HttpClient, private data: DataService) { }

  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    this.loadCerts()
    this.loadAlairasBeallitas()
    this.loadAlairoAllapot()
  }

  loadAlairoAllapot() {
    this.http.get<any>('/api/nyilvantartas/alairo-allapot/' + this.sajatIntezmeny.intezmenyId).subscribe({
      next: (r) => { this.alairo = r; },
      error: () => { this.alairo = null; },
    });
  }

  // Igazgatói (személyes) aláíró kijelölése a bizonyítványhoz (Nkt. 57. § (6a)). A backend elemzi a
  // tanúsítvány alanyát: ha szervezeti (bélyegző) tanúsítványnak látszik, kijelöli, de figyelmeztet.
  setIgazgatoi(row) {
    this.http.post<any>('/api/nyilvantartas/igazgatoi-alairo/' + this.sajatIntezmeny.intezmenyId, { id: row.id }).subscribe({
      next: (r) => {
        if (r?.figyelmeztetes) this.data.sendToast("Kijelölve, de: " + r.figyelmeztetes, "warning");
        else this.data.sendToast("Igazgatói aláíró tanúsítvány kijelölve – a bizonyítványt ez írja alá.", "success");
        this.loadCerts();
        this.loadAlairoAllapot();
      },
      error: (e) => this.data.sendToast(e?.status === 403 ? "Az igazgatói aláíró kijelöléséhez általános adminisztrátori jogosultság kell." : (e?.error?.error || "A kijelölés nem sikerült."), "error"),
    });
  }
  clearIgazgatoi() {
    this.http.post<any>('/api/nyilvantartas/igazgatoi-alairo/' + this.sajatIntezmeny.intezmenyId, { id: null }).subscribe({
      next: () => {
        this.data.sendToast("Az igazgatói jelölés megszűnt – a bizonyítványt az intézményi tanúsítvány írja alá.", "success");
        this.loadCerts();
        this.loadAlairoAllapot();
      },
      error: (e) => this.data.sendToast(e?.error?.error || "Nem sikerült.", "error"),
    });
  }

  loadAlairasBeallitas() {
    this.data.getAlairasBeallitas().subscribe({
      next: (r: any) => {
        this.tsaEnabled = !!(r?.tsa_enabled);
        this.tsaUrl = r?.tsa_url || "http://timestamp.digicert.com";
      },
      error: () => { /* alapértékek maradnak */ },
    });
  }

  saveAlairasBeallitas() {
    const url = (this.tsaUrl || "").trim();
    if (this.tsaEnabled && !/^https?:\/\//i.test(url)) {
      this.data.sendToast("Adj meg érvényes TSA URL-t (http:// vagy https://).", "error");
      return;
    }
    this.tsaMentes = true;
    this.data.setAlairasBeallitas(this.tsaEnabled ? 1 : 0, url).subscribe({
      next: (r: any) => {
        this.tsaMentes = false;
        if (r?.ok) {
          this.tsaEnabled = !!r.tsa_enabled;
          this.tsaUrl = r.tsa_url;
          this.data.sendToast("Aláírás-beállítás mentve.", "success");
        } else {
          this.data.sendToast(r?.error || "A mentés nem sikerült.", "error");
        }
      },
      error: (e) => {
        this.tsaMentes = false;
        this.data.sendToast(e?.error?.error || "A mentés nem sikerült.", "error");
      },
    });
  }

  async loadCerts(){
    await this.data.getTanusitvanyok(this.sajatIntezmeny.intezmenyId).subscribe(d=>{
      d.forEach(element => {
        element.validto = moment(element.validto).format("YYYY-MM-DD")
      });
      this.certdata=d
      console.log(this.certdata)
    this.certused = this.certdata.filter(d => d.used == 1)[0]
    })
  }

  async uploadData() {
    this.uploading = true;
    this.data.showLoading("Állományok ellenőrzése és feltöltés...")
    const formData = new FormData();
    formData.append('file', this.file);
    formData.append('password', this.certPassword || '');

    this.http.post("/api/upload/"+this.sajatIntezmeny.intezmenyId, formData).pipe(retry(3), catchError(e => {        // need to capture the 'e' here...
      this.handleError(e, this.data);   // pass to your function
      return EMPTY;          // and return empty
    })).subscribe({ next: d => {

      this.data.hideLoading()
      console.log(d)
      this.file = undefined;
      this.files = [];
      this.certPassword = "";
      this.cdis = false;
      this.loadCerts();
      if (d.toString().indexOf("OK"))
        this.data.sendToast("Sikeres importálás", "success")
      
      else
        this.data.sendToast("Hiba történt a feldolgozás során!", "error")
    }, error: () => this.data.hideLoading() });




  }
  handleError(error: HttpErrorResponse, data) {

    data.hideLoading()

    data.sendToast("Nem sikerült elküldeni a kérést!", "error")
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    this.file = file;
  }

  activate(row) {
    this.data.setTanusitvany(this.sajatIntezmeny.intezmenyId, row.id).subscribe({
      next: (r: any) => {
        // A backend {ok:true} vagy hibastátusz. Csak valódi váltásnál jelzünk sikert.
        if (r?.ok) {
          this.data.sendToast("Tanúsítvány aktiválva", "success");
        } else {
          this.data.sendToast(r?.error || "A tanúsítvány aktiválása nem sikerült.", "error");
        }
        this.loadCerts();
      },
      error: (e) => {
        console.error("Tanúsítvány aktiválási hiba:", e);
        this.data.sendToast(e?.error?.error || "A tanúsítvány aktiválása nem sikerült.", "error");
        this.loadCerts();
      },
    });
  }

  // Az e-mail S/MIME aláíráshoz kijelöli ezt a tanúsítványt (rendszerszinten egy). A backend
  // rögtön be is tölti; ha a jelszó rossz vagy nincs privát kulcs, hibát jelez és nem írja alá.
  setSmime(row) {
    this.data.setSmimeSigner(row.id).subscribe((r: any) => {
      if (r?.signer && r.signer.ok === false) this.data.sendToast("Kijelölve, de nem tölthető be: " + (r.signer.reason || "ismeretlen hiba"), "error");
      else this.data.sendToast("E-mail aláíró tanúsítvány beállítva", "success");
      this.loadCerts();
    });
  }
  clearSmime() {
    this.data.setSmimeSigner(null).subscribe(() => {
      this.data.sendToast("E-mail aláírás kikapcsolva", "success");
      this.loadCerts();
    });
  }

  remove(row) {
    if (!confirm("Biztosan törli ezt a tanúsítványt?")) return;
    this.data.deleteTanusitvany(row.id).subscribe(() => {
      this.data.sendToast("Tanúsítvány törölve", "success");
      this.loadCerts();
    });
  }

  /** A feltöltött .p12/.pfx visszaletöltése (a fájl a privát kulcsot is tartalmazza – csak admin). */
  letolt(row) {
    this.data.letoltTanusitvany(this.sajatIntezmeny.intezmenyId, row.id).subscribe({
      next: (blob: Blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = row.name || 'tanusitvany.p12';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      },
      error: (e) => this.data.sendToast(e?.status === 403 ? 'A tanúsítvány letöltéséhez adminisztrátori jogosultság kell.' : 'A tanúsítvány nem tölthető le.', 'error'),
    });
  }

  files: any[] = [];

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event) {

    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files) {
      const files: any = inputElement.files;
      // Now you can handle the files as needed
      this.prepareFilesList(files, event);
    }

  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files = [];
    this.excelData = [];
    (<HTMLInputElement>document.getElementById("fileDropRef")).value = null;
    this.cdis = false;
    //this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number, event) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            this.onFileChange(event);
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1, event);
          } else {
            this.files[index].progress += 5;
          }
        }, 20);
      }
    }, 100);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  async prepareFilesList(files: Array<any>, event = null) {
    //for (const item of files) {
    this.cdis = true;
    const item = files[0]
    item.progress = 0;
    if (item.name.indexOf(".p12") != -1 || item.name.indexOf(".pfx") != -1) {
      this.files[0] = item;
      //await this.data.getAllomany((await this.data.getFromStorage("sajatIntezmeny")).intezmenyId).subscribe(data => this.allomany = data)
      this.uploadFilesSimulator(0, event);
    } else {
      alert("Csak P12 vagy PFX fájlt lehet feltölteni!");
      this.deleteFile(0)
    }

    //}

  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }




}
